import { useState } from 'react';
import { useApp } from '../context/AppContext';
import { useI18n } from '../context/I18nContext';
import { THEMES, applyTheme, applyChatTransparency } from '../themes';

export default function ThemeSelector() {
  const { setShowThemeSelector } = useApp();
  const { t, lang } = useI18n();
  const current = localStorage.getItem('cogency_theme') || 'default';
  const [transparent, setTransparent] = useState(() => localStorage.getItem('cogency_chat_transparent') === 'true');

  const handleSelect = (key) => {
    applyTheme(key);
    localStorage.setItem('cogency_theme', key);
    setShowThemeSelector(false);
  };

  const handleToggleTransparency = (e) => {
    const val = e.target.checked;
    setTransparent(val);
    applyChatTransparency(val);
    localStorage.setItem('cogency_chat_transparent', val ? 'true' : 'false');
  };

  const getName = (theme) => {
    if (lang === 'ar') return theme.nameAr;
    if (lang === 'en') return theme.nameEn;
    return theme.name;
  };

  return (
    <div className="modal-overlay show" onClick={e => e.target === e.currentTarget && setShowThemeSelector(false)}>
      <div className="modal">
        <div className="modal-header">
          <h2>🎨 {t('themes')}</h2>
          <button className="modal-close" onClick={() => setShowThemeSelector(false)}>&times;</button>
        </div>
        <div className="modal-body">
          <p className="theme-intro">{t('themesIntro')}</p>
          <div className="theme-grid">
            {Object.entries(THEMES).map(([key, theme]) => (
              <button
                key={key}
                className={`theme-thumb ${current === key ? 'active' : ''}`}
                onClick={() => handleSelect(key)}
                title={getName(theme)}
                style={{
                  backgroundImage: theme.image || undefined,
                  backgroundColor: theme.image ? undefined : theme.bg,
                }}
              >
                {!theme.image && (
                  <div className="theme-color-preview" style={{ background: `linear-gradient(135deg, ${theme.bg} 50%, ${theme.accent} 50%)` }} />
                )}
                <span className="theme-label">{getName(theme)}</span>
              </button>
            ))}
          </div>
          <div className="theme-transparency-toggle">
            <label className="toggle-label">
              <span>{t('chatTransparency')}</span>
              <input type="checkbox" checked={transparent} onChange={handleToggleTransparency} />
              <span className="toggle-slider"></span>
            </label>
            <p className="toggle-hint">{t('chatTransparencyHint')}</p>
          </div>
        </div>
      </div>
    </div>
  );
}
